// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f23711c7","617":"7bd24c26","949":"c356e6a0"}[chunkId] + ".chunk.js";
};